module.exports = __webpack_public_path__ + "static/Happy-robot-b8e46655fe7f46ef4574f932ad9106c7.png";